import { render, staticRenderFns } from "./SavedCardsQuickView.vue?vue&type=template&id=6fff2d0e&scoped=true"
import script from "./SavedCardsQuickView.vue?vue&type=script&lang=js"
export * from "./SavedCardsQuickView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff2d0e",
  null
  
)

export default component.exports